import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Star } from '@root/shared/ui-kit'

import { useFavorite } from '../../hooks/use-favorite'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  size?: number
} & ClassNameProps

export const PairInformationFavorite: React.FC<Props> = ({
  pair,
  size = 20,
  className,
}) => {
  const { toggleFavorite } = useFavorite()
  const [isFavorite] = useAtom(pair.favorite)

  const handleFavoriteClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    e.stopPropagation()
    e.preventDefault()
    toggleFavorite(pair)
  }

  return (
    <Root onClick={handleFavoriteClick} className={className}>
      <StarStyled filled={isFavorite} size={size} />
    </Root>
  )
}

const Root = styled.div`
  pointer-events: auto;
  display: grid;
  place-items: center;
  position: relative;

  cursor: pointer;
`

const StarStyled = styled(Star)`
  --star-empty-color: var(--text-9);
  --star-empty-color-hover: var(--text-11);
`
